// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5175badb","455":"511f5118"}[chunkId] + ".chunk.js";
};